// import {scan} from "react-scan"
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import App from './App.tsx'
import * as Sentry from "@sentry/react";

// scan({
//     enabled: true
// })

createRoot(document.getElementById('root')!, {
	onUncaughtError: Sentry.reactErrorHandler((err, errInfo) => {
		console.warn('UncaughtError', err, errInfo)
	}),
	onCaughtError: Sentry.reactErrorHandler(),
	onRecoverableError: Sentry.reactErrorHandler(),
}).render(
	<StrictMode>
		<App/>
	</StrictMode>,
)
